<template>
    <div class="basic_wrap">

        <img class="title" src="../images/Air-drop.png" alt="">
        <button class="open-btn" @click="show_input = true">Receber</button>


        <div class="rules">
            <p>Regras de lançamento aéreo</p>
            <p>1. Depois de clicar para reivindicar, insira o número do seu celular para obter as recompensas do lançamento
                aéreo.</p>
            <p>2. Existem restrições ao recebimento de airdrops. Por favor, leia atentamente as regras de lançamento aéreo
                publicadas pelo Telegram. Somente jogadores que atendam às condições podem obtê-lo.
            </p>
        </div>

        <div class="input_wrap" v-show="show_input">
            <div class="sum">
                <!-- <p class="ttt">Digite o número do celular para receber</p> -->
                <input type="text" v-model="phone" placeholder="número de telefone" class="inpt">
                <button class="submit" @click="gogogo()">Receber</button>
            </div>
        </div>

    </div>
</template>

<script>
import Vue from "vue";
import { Dialog, Toast, Notify } from "vant";
import Clipboard from "v-clipboard";
Vue.use(Clipboard);
import Axios from 'axios'

export default {
    name: "airdrop",
    data() {
        return {
            lang: this.$i18n.locale || "en_us",
            can_click: false,
            expect_no:null,
            phone:"",
            show_input: false,
            url: "https://admin.22ola.com",
            package: {},
        }
    },
    created() {

        this.$parent.footer('user', false);
    },
    mounted() {
        let myQuery = this.$route.query;
        if (myQuery.e) {
            Toast.clear();
            this.expect_no = myQuery.e;
            this.init(myQuery.e);
        }
        else {

            return;
        }

    },
    methods: {
        //获取当前空投时间
        init(e) {

            let _this = this;
            Axios.get(this.url + `/api/airbox/getAirdrop?e=${e}&language=pt_br`)
                .then(function (res) {
                    //console.log(res);
                    if (res.data.code == 0) {
                        Notify({ type: 'danger', message: res.data.msg });
                    } else {
                        Notify({ type: 'success', message: res.data.msg });
                        _this.package = res.data.data;
                    }
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                })
                .finally(function () {
                    // always executed
                });

        },
        gogogo() {
            //let _this = this;
            if(this.phone.length < 10){
                Notify({ type: 'danger', message: "Por favor insira o número de telefone" });
                return;
            }
            Axios.post(this.url + `/api/airbox/receive`, {
                language:"pt_br",
                phone:this.phone,
                expect:this.expect_no,
            }).then(function (res) {
                console.log(res);
                if (res.data.code == 0) {
                    Notify({ type: 'danger', message: res.data.msg });
                } else {
                    Notify({ type: 'success', message: "Resgatado com sucesso e recebido uma recompensa de R$" + res.data.data });
                    setTimeout(() => {
                        window.location.href = "https://22ola.com"
                    }, 3500);
                }
            }).catch(function (error) {
                // handle error
                console.log(error);
            }).finally(function () {
                // always executed
            });
        }




    },
}
</script>

<style lang="less" scoped>
.ttt {
    color: #e5e5e5;
    margin-bottom: 10px;
}

.submit {
    display: block;
    width: 50%;
    height: 30px;
    background-image: url("../images/ybtn.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: white;
    bottom: 40%;
    font-weight: 700;
    font-size: 0.45rem;
    margin: 15px auto;
    margin-bottom: 0;
}

.inpt {
    height: 1rem;
    width: 100%;
    // border: 1px solid #d6d5d5;
    border-radius: 3px;
    text-align: center;
    color: #fff;
    background: #010f33d6;
}

.sum {
    width: 8rem;
    // height: 3rem;
    padding: 20px;
    border-radius: 0.2rem;
    background: rgb(2, 30, 102);
    // border: 1px solid #84A559;
    // margin: 0 auto;
    position: absolute;
    top: 30%;
    left: 50%;
    margin-left: -4rem;
}

.input_wrap {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
}

.copy {
    background-color: rgb(135, 244, 250);
    color: rgb(74, 168, 255);
    padding: 5px;
    border-radius: 3px;
    display: block;
    margin: 0 auto;
}

.no {
    text-align: center;
    color: goldenrod;
    font-size: 0.4rem;
}

.basic_wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    max-width: 415px;
    background-image: url("../images/airdrop_bg.png");
    //    background-repeat:no-repeat;
    // background-attachment:fixed;
    background-position: 0px -60px;
    background-size: 100%;
}

.title {
    width: 80%;
    display: block;
    margin: 15px auto;
}

.open-btn {
    position: absolute;
    width: 50%;
    height: 50px;
    background-image: url("../images/ybtn.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: white;
    bottom: 40%;
    left: 25%;
    font-weight: 700;
    font-size: 0.45rem;
}

.rules {
    position: absolute;
    width: 100%;
    bottom: 0%;
    color: goldenrod;
    background: rgba(0, 0, 0, 0.798);
    padding: 10px;
    box-sizing: border-box;
}

.rules b {}

.rules p {
    line-height: 22px;
    // font-weight: 700;
    font-size: 0.3rem;
}
</style>
